const FAQ = () => import("@/views/faq/FAQ.vue");

export default {
  path:"faq",
  meta: { 
    label: "FAQ" 
  },
  component: {
    render(c) {
      return c("router-view");
    },
  }, 
  children:[
    {
        path:"",
        meta: {
            requiresAuth: true,
        },
        component:FAQ,
    },
  ],
};
  